import { render, staticRenderFns } from "./NavPageView.vue?vue&type=template&id=4c3dc4d3&scoped=true&"
import script from "./NavPageView.vue?vue&type=script&lang=js&"
export * from "./NavPageView.vue?vue&type=script&lang=js&"
import style0 from "./NavPageView.vue?vue&type=style&index=0&id=4c3dc4d3&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3dc4d3",
  null
  
)

export default component.exports